<template>
  <v-dialog
    v-model="select_city_dialog"
    transition="dialog-top-transition"
    :fullscreen="isMobile"
    content-class="cities-dialog-wrapper"
  >
    <v-sheet class="cities-dialog">
      <v-app-bar
        dark
        flat
        color="orange-darken-2"
      >
        <v-col cols=auto>
          <v-toolbar-title class="text-white">Выберите город</v-toolbar-title>
        </v-col>
        <v-col class="button-close" cols=auto>
          <v-btn
            icon
            dark
            @click="clozeDialog"
          >
            <v-icon color="white" >{{ mdiClose }}</v-icon>
          </v-btn>
        </v-col>
      </v-app-bar>

      <Suspense v-if="select_city_dialog">
        <CitySelect />
        <template #fallback>
          <v-skeleton-loader type="image" class="v-col-12 d-block" />
        </template>
      </Suspense>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { mdiClose, mdiMagnify } from '@mdi/js';
import { defineAsyncComponent } from 'vue';

import "../scss/components/CitySelect.scss";

export default {
  data: function () {
    return {
      mdiClose,
    };
  },
  components: {
		CitySelect: defineAsyncComponent(() => import("./CitySelect.vue"))
  },
  computed: {
    select_city_dialog: {
      get() {
        return this.$store.state.citiesM.city_select_dialog
      },
      set(value) { this.$store.commit("CLOZE_SELECT_CITY_DIALOG") }
    },
    ... mapState({
      isMobile: (state) => state.isMobile,
    })
  },
  methods: {
		clozeDialog() {
      this.$store.commit("CLOZE_SELECT_CITY_DIALOG");
		},
  },
};
</script>

<script setup>

import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'

</script>
